import { render } from "./UpdatePaymentRequestRefund.vue?vue&type=template&id=7a9b85f9&scoped=true"
import script from "./UpdatePaymentRequestRefund.vue?vue&type=script&lang=ts"
export * from "./UpdatePaymentRequestRefund.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7a9b85f9"

export default script